export const CODE_REQUEST = 'CODE_REQUEST';
export const CODE_SUCCESS = 'CODE_SUCCESS';
export const CODE_ERROR   = 'CODE_ERROR';

export const REGI_STEP2_REQUEST = 'REGI_STEP2_REQUEST';
export const REGI_STEP2_SUCCESS = 'REGI_STEP2_SUCCESS';
export const REGI_STEP2_ERROR   = 'REGI_STEP2_ERROR';